import { RestService } from "./RestService";

export class FeatureFlagService extends RestService {
  constructor() {
    super("/api/v1/feature-flags");
  }

  async list() {
    return await this.getImpl("");
  }

  async update(values) {
    return await this.putImpl("", values);
  }
}
